import ConfirmationModal from './ConfirmationModal';

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/modals/confirmation-modal/index.js